import React from 'react';
import { Helmet } from 'react-helmet';
import PostCard from '../components/PostCard';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';

function Home() {
  const [notification, setNotification] = React.useState('');
  const [favorites, setFavorites] = React.useState([]);

  const posts = [
    {
      id: 1,
      title: 'Μεσογειακές Γεύσεις για την Τέλεια Εκδήλωση σας',
      excerpt: 'Ανακαλύψτε πώς οι μεσογειακές συνταγές μπορούν να μεταμορφώσουν την εκδήλωσή σας σε μια αξέχαστη γαστρονομική εμπειρία με φρέσκα υλικά και αυθεντικές γεύσεις.',
      date: '15 Ιανουαρίου 2025',
      author: 'Μαρία Παπαδοπούλου',
      image: '/images/1.jpg'
    },
    {
      id: 2,
      title: 'Τέχνη Παρουσίασης Πιάτων για Εταιρικές Εκδηλώσεις',
      excerpt: 'Μάθετε τα μυστικά της επαγγελματικής παρουσίασης πιάτων που θα εντυπωσιάσουν τους καλεσμένους σας και θα αναδείξουν την κομψότητα της εκδήλωσής σας.',
      date: '12 Ιανουαρίου 2025',
      author: 'Νίκος Αντωνίου',
      image: '/images/2.jpg'
    },
    {
      id: 3,
      title: 'Οργανικά Υλικά και Βιώσιμο Catering',
      excerpt: 'Εξερευνήστε τον κόσμο του βιώσιμου catering με οργανικά προϊόντα που συνδυάζουν την εξαιρετική γεύση με την περιβαλλοντική υπευθυνότητα.',
      date: '10 Ιανουαρίου 2025',
      author: 'Ελένη Κωνσταντίνου',
      image: '/images/3.jpg'
    },
    {
      id: 4,
      title: 'Μενού για Γάμους: Από την Παράδοση στη Σύγχρονη Κουζίνα',
      excerpt: 'Ανακαλύψτε πώς να συνδυάσετε παραδοσιακές γεύσεις με σύγχρονες τεχνικές για να δημιουργήσετε το τέλειο μενού γάμου που θα ξεχωρίσει.',
      date: '8 Ιανουαρίου 2025',
      author: 'Δημήτρης Γεωργίου',
      image: '/images/4.jpg'
    },
    {
      id: 5,
      title: 'Σεζόν Εορτών: Ιδέες Catering για Χειμερινές Εκδηλώσεις',
      excerpt: 'Εμπνευστείτε από τις καλύτερες ιδέες catering για χειμερινές εκδηλώσεις με ζεστά πιάτα, εορταστικές διακοσμήσεις και ατμοσφαιρικές παρουσιάσεις.',
      date: '5 Ιανουαρίου 2025',
      author: 'Σοφία Μιχαηλίδου',
      image: '/images/5.jpg'
    }
  ];

  const handleFavorite = (postId) => {
    if (favorites.includes(postId)) {
      setFavorites(favorites.filter(id => id !== postId));
      showNotification('Το άρθρο αφαιρέθηκε από τα αγαπημένα σας');
    } else {
      setFavorites([...favorites, postId]);
      showNotification('Το άρθρο προστέθηκε στα αγαπημένα σας');
    }
  };

  const handleShare = () => {
    showNotification('Η λειτουργία κοινοποίησης θα είναι σύντομα διαθέσιμη');
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(''), 3000);
  };

  return (
    <>
      <Helmet>
        <title>Nalumer | Υπηρεσία Catering με Κομψότητα και Γεύση</title>
        <meta
          name="description"
          content="Ανακαλύψτε το Nalumer: catering με κομψότητα και γεύση για γάμους, εταιρικές και οικογενειακές εκδηλώσεις. Ιδέες, συνταγές και επαγγελματική οργάνωση."
        />
        <meta property="og:title" content="Nalumer | Υπηρεσία Catering με Κομψότητα και Γεύση" />
        <meta
          property="og:description"
          content="Ανακαλύψτε το Nalumer: catering με κομψότητα και γεύση για γάμους, εταιρικές και οικογενειακές εκδηλώσεις. Ιδέες, συνταγές και επαγγελματική οργάνωση."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://nalumer.com" />
        <link rel="canonical" href="https://nalumer.com" />
      </Helmet>

      <div className="hero-section">
        <div className="hero-content">
          <h1>Καλώς ήρθατε στο Nalumer</h1>
          <p>
            Ανακαλύψτε την τέχνη του catering με κομψότητα, γεύση και
            δημιουργικότητα. Προσφέρουμε κετερινγκ εξαιρετικές υπηρεσίες για
            κάθε εκδήλωση, από οικογενειακές συγκεντρώσεις μέχρι εταιρικά
            events.
          </p>
        </div>
      </div>

      <section className="features-section">
        <h2 className="features-title">Γιατί να Επιλέξετε το Nalumer</h2>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <FaStar />
            </div>
            <h3>Εξαιρετική Ποιότητα</h3>
            <p>
              Χρησιμοποιούμε μόνο τα πιο φρέσκα και εκλεκτά υλικά για να
              δημιουργήσουμε πιάτα που θα σας εντυπωσιάσουν. Κάθε γεύμα είναι
              μια γαστρονομική εμπειρία.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaHeart />
            </div>
            <h3>Πάθος για τη Γεύση</h3>
            <p>
              Η αγάπη μας για το φαγητό φαίνεται σε κάθε λεπτομέρεια.
              Δημιουργούμε μενού που συνδυάζουν παράδοση με σύγχρονες τεχνικές
              μαγειρικής.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaShoppingCart />
            </div>
            <h3>Προσαρμοσμένες Λύσεις</h3>
            <p>
              Κάθε εκδήλωση είναι μοναδική και εμείς προσαρμόζουμε τις υπηρεσίες
              μας στις ανάγκες σας. Από μικρές γρήγορα φαγητό συγκεντρώσεις
              μέχρι μεγάλα events.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaHome />
            </div>
            <h3>Επαγγελματισμός</h3>
            <p>
              Η ομάδα μας αποτελείται από έμπειρους επαγγελματίες που φροντίζουν
              κάθε λεπτομέρεια για να κάνουν την εκδήλωσή σας τέλεια.
            </p>
          </div>
        </div>

        <div className="stats-section">
          <div className="stats-grid">
            <div className="stat-item">
              <h4>500+</h4>
              <p>Ικανοποιημένοι Πελάτες</p>
            </div>
            <div className="stat-item">
              <h4>10+</h4>
              <p>Χρόνια Εμπειρίας</p>
            </div>
            <div className="stat-item">
              <h4>200+</h4>
              <p>Μοναδικές Συνταγές</p>
            </div>
            <div className="stat-item">
              <h4>98%</h4>
              <p>Ικανοποίηση Πελατών</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-blog-section">
        <h2>Η Τέχνη του Catering στα Χέρια Ειδικών</h2>

        <p>
          Το Nalumer είναι περισσότερο από μια απλή υπηρεσία catering. Είναι
          ένας προορισμός για όσους αναζητούν την τελειότητα στην γαστρονομία
          και την εκδήλωση. Με πάνω από δέκα ελληνικά φαγητα χρόνια εμπειρίας
          στον χώρο, έχουμε δημιουργήσει μια φήμη αριστείας που βασίζεται στην
          ποιότητα, την καινοτομία και την προσοχή στη λεπτομέρεια.
        </p>

        <p>
          Κάθε εκδήλωση που αναλαμβάνουμε είναι μια ευκαιρία να δημιουργήσουμε
          κάτι μοναδικό. Από την επιλογή των υλικών μέχρι την τελική παρουσίαση,
          κάθε βήμα σχεδιάζεται με μέριμνα και επαγγελματισμό. Συνεργαζόμαστε
          στενά με τους πελάτες μας για να κατανοήσουμε το όραμά τους και να το
          μετατρέψουμε σε πραγματικότητα.
        </p>

        <p>
          Η ομάδα μας αποτελείται από έμπειρους σεφ, διαιτολόγους κετερινγκ και
          event planners που φέρνουν τη δική τους εξειδίκευση και
          δημιουργικότητα σε κάθε project. Χρησιμοποιούμε μόνο βιολογικά και
          τοπικά προϊόντα όποτε είναι δυνατόν, υποστηρίζοντας έτσι τους τοπικούς
          παραγωγούς και την βιώσιμη γαστρονομία.
        </p>

        <p>
          Το blog μας είναι ένας χώρος όπου μοιραζόμαστε την αγάπη μας για το
          φαγητό και τις εκδηλώσεις. Εδώ θα βρείτε εμπνευσμένες ιδέες, συνταγές
          που έχουν δοκιμαστεί από την ομάδα μας, συμβουλές για τον σχεδιασμό
          εκδηλώσεων και πολλά άλλα. Στόχος μας είναι να σας εμπνεύσουμε και να
          σας βοηθήσουμε να δημιουργήσετε αξέχαστες στιγμές.
        </p>

        <div className="cta-section">
          <h3>Έτοιμοι να Ξεκινήσουμε;</h3>
          <a href="/contact" className="cta-button">
            Επικοινωνήστε Μαζί Μας
          </a>
        </div>
      </section>

      <section className="posts-section">
        <h2>Τα Τελευταία μας Άρθρα</h2>
        <div className="posts-grid">
          {posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              onFavorite={handleFavorite}
              onShare={handleShare}
            />
          ))}
        </div>
      </section>

      {notification && (
        <div className="notification">
          <p>{notification}</p>
        </div>
      )}
    </>
  );
}

export default Home;